function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import atIds from "@brandwatch/axiom-automation-testing/ids";
import { Avatar, Button, ButtonGroup, Candytar, Dropdown, DropdownContent, DropdownContext, DropdownSource, DropdownTarget, Grid, GridCell, Heading, Link, Paragraph } from "@brandwatch/axiom-components";
import { translate } from "@brandwatch/axiom-localization";
import { stringToColor } from "@brandwatch/axiom-utils";
const t = translate({
  "Sign out": {
    de: "Abmelden",
    es: "Cerrar Sesión",
    fr: "Se déconnecter"
  }
});
export default class UserMenu extends Component {
  render() {
    const {
      children,
      firstName,
      lastName,
      email,
      imageSrc,
      onLogout,
      ...rest
    } = this.props;
    const color = stringToColor(email);
    const {
      axiomLanguage
    } = this.context;
    const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`;
    return /*#__PURE__*/React.createElement(Dropdown, _extends({
      position: "bottom"
    }, rest), /*#__PURE__*/React.createElement(DropdownTarget, null, /*#__PURE__*/React.createElement(Link, {
      "data-ax-at": atIds.UserMenu.activate
    }, /*#__PURE__*/React.createElement(Avatar, {
      size: "2rem",
      src: imageSrc
    }, /*#__PURE__*/React.createElement(Candytar, {
      color: color,
      initials: initials,
      size: "2rem"
    })))), /*#__PURE__*/React.createElement(DropdownSource, null, /*#__PURE__*/React.createElement(DropdownContext, {
      width: "auto"
    }, /*#__PURE__*/React.createElement(DropdownContent, null, /*#__PURE__*/React.createElement(Grid, {
      gutters: "large",
      responsive: false,
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(GridCell, {
      fill: true
    }, /*#__PURE__*/React.createElement(Heading, {
      space: "x0",
      textSize: "headtitle"
    }, firstName, " ", lastName), /*#__PURE__*/React.createElement(Paragraph, {
      space: "x0",
      textColor: "subtle"
    }, email), /*#__PURE__*/React.createElement(ButtonGroup, {
      space: "x4"
    }, /*#__PURE__*/React.createElement(Button, {
      "data-ax-at": atIds.UserMenu.logout,
      onClick: onLogout
    }, t("Sign out", axiomLanguage)))), /*#__PURE__*/React.createElement(GridCell, {
      shrink: true
    }, /*#__PURE__*/React.createElement(Avatar, {
      size: "4.5rem",
      src: imageSrc
    }, /*#__PURE__*/React.createElement(Candytar, {
      color: color,
      initials: initials,
      size: "4.5rem"
    }))))), children)));
  }

}

_defineProperty(UserMenu, "contextTypes", {
  axiomLanguage: PropTypes.string
});